module.exports = __webpack_public_path__ + "img/device_settings.d9839154.svg";